import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScrollToEndProps } from './scroll-to-end.props';

function ScrollToEnd({ containerRef, className }: ScrollToEndProps) {
  const handleScrollToEnd = () => {
    const container = containerRef.current;
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  };

  return (
    <button
      type="button"
      className={`cursor-pointer absolute z-10 bg-white rounded-full bg-clip-padding border text-gray-600  right-auto border-black/10 bg-token-surface-primary bottom-[27.5vh] p-1 ${className}`}
      onClick={handleScrollToEnd}
    >
      <FontAwesomeIcon icon={faArrowDown} className="px-2 text-black" />
    </button>
  );
}

export default ScrollToEnd;
